var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M0,385.38c0,21.176,17.167,38.345,38.345,38.345h435.311c21.165,0,38.324-17.148,38.344-38.307 v-73.509H0V385.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.656,88.275H38.345C17.167,88.275,0,105.443,0,126.62v73.471h512v-73.509 C511.98,105.424,494.821,88.275,473.656,88.275z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 200.089,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 111.81
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 194.21,
    y: 203.029,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.64,
    y: 203.029,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.93,
    y: 231.279,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.08,
    y: 203.029,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.36,
    y: 231.279,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.93,
    y: 203.029,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.36,
    y: 203.029,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.21,
    y: 231.279,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.64,
    y: 231.279,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.08,
    y: 231.279,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.64,
    y: 259.529,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.93,
    y: 287.779,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.36,
    y: 287.779,
    style: {
      fill: "#FF4B55"
    },
    width: 24.717,
    height: 28.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.93,
    y: 259.529,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.36,
    y: 259.529,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.64,
    y: 287.779,
    style: {
      fill: "#F5F5F5"
    },
    width: 24.717,
    height: 28.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M317.793,203.035v79.448c0,34.128-27.666,61.793-61.793,61.793s-61.793-27.666-61.793-61.793 v-79.448H317.793 M322.206,198.62h-4.414H194.206h-4.414v4.414v79.448c0,36.507,29.7,66.207,66.207,66.207 s66.207-29.701,66.207-66.207v-79.448V198.62L322.206,198.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M218.924,287.779v-28.249h-24.717v22.953c0,1.789,0.118,3.546,0.267,5.297L218.924,287.779 L218.924,287.779z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M317.526,287.779h-24.45v28.248h14.774C313.211,307.758,316.644,298.14,317.526,287.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M204.149,316.028h14.774v-28.248h-24.45C195.355,298.14,198.788,307.758,204.149,316.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M293.075,287.779h24.45c0.149-1.749,0.267-3.508,0.267-5.297v-22.952h-24.717V287.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M218.924,331.833v-15.805H204.15C208.107,322.133,213.122,327.467,218.924,331.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M307.849,316.028h-14.774v15.806C298.876,327.467,303.89,322.133,307.849,316.028z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M218.924,331.833c7.195,5.415,15.567,9.345,24.717,11.202v-27.007h-24.717V331.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M268.358,343.034c9.15-1.857,17.523-5.788,24.717-11.202v-15.805h-24.717V343.034z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M268.358,316.028h-24.717v27.008c3.993,0.811,8.126,1.241,12.359,1.241 c4.233,0,8.365-0.43,12.359-1.241v-27.008H268.358z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M211.27,156.29c-5.378-0.832-10.88-1.432-16.489-1.779c-4.338,3.571-8.473,7.294-12.398,11.15 c3.942,9.515,7.883,19.03,11.823,28.545c7.913-3.277,16.021-5.9,24.247-7.867C216.059,176.324,213.664,166.307,211.27,156.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M271.002,151.604c-4.833-2.445-9.837-4.706-15.003-6.765c-5.165,2.06-10.17,4.321-15.003,6.765 c0.803,10.267,1.607,20.534,2.41,30.803c8.382-0.657,16.804-0.657,25.186,0C269.395,172.139,270.199,161.872,271.002,151.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M329.616,165.661c-3.925-3.855-8.061-7.578-12.398-11.15c-5.609,0.346-11.111,0.947-16.489,1.779 c-2.395,10.017-4.789,20.033-7.184,30.049c8.226,1.967,16.334,4.589,24.247,7.867C321.734,184.69,325.676,175.175,329.616,165.661z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M240.996,151.604c-5.154-1.663-10.456-3.118-15.894-4.346c-4.798,2.841-9.411,5.858-13.832,9.033 c2.394,10.017,4.789,20.033,7.183,30.049c8.226-1.967,16.569-3.277,24.952-3.933C242.602,172.139,241.799,161.872,240.996,151.604z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M300.729,156.29c-4.422-3.175-9.035-6.193-13.832-9.033c-5.438,1.228-10.741,2.685-15.894,4.346 c-0.803,10.267-1.607,20.534-2.41,30.803c8.383,0.655,16.726,1.966,24.952,3.933C295.94,176.324,298.334,166.307,300.729,156.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M241.96,163.925c-9.345,0.73-18.646,2.191-27.817,4.385c-0.479-2.003-0.958-4.007-1.437-6.011 c9.485-2.266,19.105-3.778,28.771-4.535C241.639,159.818,241.799,161.871,241.96,163.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M242.925,176.245c-8.703,0.681-17.366,2.042-25.907,4.084c-0.48-2.003-0.958-4.007-1.437-6.009 c8.855-2.118,17.838-3.529,26.862-4.234C242.602,172.137,242.764,174.193,242.925,176.245z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M285.326,178.32c-2.155-0.383-4.316-0.724-6.482-1.022c-3.562-0.492-6.215-3.516-5.906-6.915l0,0 c0.308-3.398,3.713-5.863,7.59-5.327c2.325,0.32,4.646,0.685,6.959,1.097c3.859,0.682,6.357,4.082,5.604,7.406l0,0 C292.341,176.891,288.873,178.945,285.326,178.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M320.157,188.497c-8.215-3.402-16.636-6.125-25.175-8.168c0.48-2.003,0.958-4.007,1.437-6.009 c8.855,2.116,17.585,4.94,26.103,8.468C321.734,184.69,320.945,186.594,320.157,188.497z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M317.952,169.958c-0.873,2.407-3.817,3.552-6.599,2.647c-2.781-0.906-4.483-3.55-3.779-6.012 c0.704-2.462,3.686-3.765,6.636-2.806C317.163,164.744,318.826,167.551,317.952,169.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M204.424,166.594c0.703,2.464-1,5.109-3.779,6.012c-2.781,0.9-5.725-0.245-6.599-2.647 c-0.874-2.408,0.79-5.214,3.742-6.171C200.738,162.832,203.722,164.134,204.424,166.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M254.589,162.548c0.006,2.047-1.834,3.714-4.114,3.784c-2.279,0.073-4.222-1.481-4.342-3.52 c-0.119-2.04,1.719-3.806,4.111-3.883C252.637,158.854,254.58,160.501,254.589,162.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M265.865,162.811c-0.121,2.044-2.065,3.593-4.342,3.52c-2.279-0.07-4.119-1.737-4.114-3.784 c0.009-2.045,1.953-3.697,4.344-3.619C264.146,159.001,265.982,160.77,265.865,162.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M260.007,172.079c-0.057,2.047-1.85,3.657-4.008,3.657c-2.156-0.001-3.949-1.609-4.008-3.657 c-0.056-2.041,1.737-3.755,4.008-3.75C258.27,168.324,260.063,170.036,260.007,172.079z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.5ab8b02fa0c3ce6876ab9be74f8a30e2.svg";
export { ForwardRef as ReactComponent };